import icon_back from "../assets/icons/todo-back-button.svg";
import AddButon from "./AddButon";
import ItemFilter from "./ItemFilter";
import { useNavigate } from "react-router-dom";
import EditableText from "./EditableText";
import { useState } from "react";
import FormTodo from "./FormTodo";
const ActivityItemNav = (props) => {
  const [itemActivity, setItemActivity] = useState(props.item);
  const navigate = useNavigate();

  const handleBack = () => {
    return navigate("/");
  };
  const handleTextChange = (newText) => {
    props.onChange(newText);
  };
  return (
    <>
      <FormTodo />
      <div className="w-full flex flex-column items-center justify-between">
        <div className="flex flex-row items-center justify-between">
          <img
            data-cy="todo-back-button"
            onClick={() => handleBack()}
            className="mr-5 cursor-pointer"
            src={icon_back}
            alt="icon back"
          />
          <EditableText text={itemActivity.title} onChange={handleTextChange} />
        </div>
        <div className="flex flex-row items-center gap-5">
          <ItemFilter />
          <AddButon />
        </div>
      </div>
    </>
  );
};

export default ActivityItemNav;
